module.exports = __webpack_public_path__ + "img/bm.b9eaa9dd.png";